import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  class: "jl2-custom-filled-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.0332 18.8322H13.5032C13.3002 18.8322 13.1174 18.9549 13.0405 19.1428L11.7524 22.2896C11.6755 22.4775 11.4926 22.6002 11.2896 22.6002H10.1625C9.80257 22.6002 9.56054 22.2313 9.70388 21.9011L15.5211 8.50109C15.6004 8.3184 15.7805 8.2002 15.9797 8.2002H17.2075C17.4066 8.2002 17.5866 8.31822 17.666 8.50072L23.4961 21.9007C23.6397 22.231 23.3977 22.6002 23.0376 22.6002H21.9224C21.7206 22.6002 21.5385 22.4788 21.4609 22.2925L20.0248 18.8448C20.0223 18.8388 20.0267 18.8322 20.0332 18.8322ZM14.1086 16.5931C13.9724 16.9223 14.2144 17.2842 14.5706 17.2842H18.6437C18.9999 17.2842 19.2419 16.9223 19.1057 16.5931L17.0692 11.6693C16.8989 11.2574 16.3155 11.2574 16.1452 11.6693L14.1086 16.5931Z",
      fill: "currentColor",
      class: "content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 31C24.28 31 31 24.28 31 16C31 7.72 24.28 1 16 1C7.72 1 1 7.72 1 16C1 24.28 7.72 31 16 31Z",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ])))
}